module.exports = __webpack_public_path__ + "static/media/rename-columns-icon.ff9b7b7d.svg";